//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

// === API ===
import { removeListener, onTasksValidated, 
          onTasksAvailable, onUsersAvailable, 
          onUsersActive, requestUsersActive, 
          requestTasksAvailable, requestTasksValidated, 
          requestUsersAvailable, onServerStartTime, 
          requestServerStartTime } 
  from 'api/prokey/prokey.websocket';
//#endregion

//-----------------------------------------------------------------
export function ProkeyStatsPanel() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ tasks_validated , setTasksValidated ] = useState( 0 );
  const [ tasks_available , setTasksAvailable ] = useState( 0 );
  const [ users_available , setUsersAvailable ] = useState( 0 );
  const [ users_prokeying , setUsersProkeying ] = useState( 0 );
  const [ server_start,     setServerStart    ] = useState('-');

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      flex      : '1 1 45%' ,
      minWidth  : '25rem'   ,
      minHeight : '19rem'   ,
      height    : '100%'    ,
      padding   : '0.5rem'  ,
      borderRadius : '1rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const CONTAINER = {
    sx      : _styles.container,
    variant : 'primary' ,
  }

  //#endregion


  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTasksValidated( data ) {
      //-----------------------------------------------------------------
      setTasksValidated( data.count )    
    }

    function handleTasksAvailable( data ) {
      //-----------------------------------------------------------------    
      setTasksAvailable( data.count );    
    }

    function handleUsersAvailable( data ) {
      //-----------------------------------------------------------------   
      setUsersAvailable( data.count );     
    }

    function handleUsersActive( data ) {
      //-----------------------------------------------------------------   
      setUsersProkeying( data.count );
    }

    function handleServerStartTime( data ) {
      //-----------------------------------------------------------------
      setServerStart(data.startTime);
    }

      onTasksValidated(handleTasksValidated);    
      onTasksAvailable(handleTasksAvailable);
      onUsersAvailable(handleUsersAvailable);
      onUsersActive(handleUsersActive); 
      onServerStartTime(handleServerStartTime);
   
      requestUsersActive();
      requestTasksValidated();
      requestTasksAvailable();
      requestUsersAvailable();      
      requestServerStartTime();      
      
    return () => {
      
      removeListener( 'TASKS-VALIDATED-COUNT', handleTasksValidated  );
      removeListener( 'TASKS-AVAILABLE-COUNT', handleTasksAvailable  );
      removeListener( 'USERS-AVAILABLE-COUNT', handleUsersAvailable  );
      removeListener( 'USERS-ACTIVE-COUNT'   , handleUsersActive     );
      removeListener( 'SERVER-START-TIME'    , handleServerStartTime );

    };
  }, []);

  
  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Card {...CONTAINER}>
        <CardHeader title='Processing Data' />
        <CardContent>
          <Table size='small' width='100%' height='100%'>
            <TableBody>
              {/* <TableRow>
                <TableCell>Tasks Validated</TableCell>
                <TableCell align='right'>{tasks_validated}</TableCell>
              </TableRow> */}
              <TableRow>
                <TableCell>Server Start Time</TableCell>
                <TableCell align='right'>{server_start}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Tasks Available</TableCell>
                <TableCell align='right'>{tasks_available}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Users Keying</TableCell>
                <TableCell align='right'>{users_prokeying}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Users Available</TableCell>
                <TableCell align='right'>{users_available}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  }; 

  //#endregion

  return display();
}